import React from "react";
import { AttendanceException } from "../services/model/AttendanceException";
import NoShowActionModal from "./NoShowActionModal";
import SupervisorClockActionModal from "./SupervisorClockActionModal";
import NoDataActionModal from "./NoDataActionModal";
import GeofenceActionModal from "./GeofenceActionModal";
import GenericResolveModal from "./GenericResolveModal";

interface ExceptionActionModalRouterProps {
  selectedException: AttendanceException | null;
  onClose: () => void;
  onResolve: (id: string, action: string, reason?: string) => void;
}

const ExceptionActionModalRouter: React.FC<ExceptionActionModalRouterProps> = ({
  selectedException,
  onClose,
  onResolve,
}) => {
  if (!selectedException) return null;
  const open = Boolean(selectedException);

  switch (selectedException.exception_type) {
    case "no_show":
      return (
        <NoShowActionModal
          exception={selectedException}
          open={open}
          onClose={onClose}
          onResolve={onResolve}
        />
      );
    case "supervisor_clock":
      return (
        <SupervisorClockActionModal
          exception={selectedException}
          open={open}
          onClose={onClose}
          onResolve={onResolve}
        />
      );
    case "no_data":
      return (
        <NoDataActionModal
          exception={selectedException}
          open={open}
          onClose={onClose}
          onResolve={onResolve}
        />
      );
    case "geofence":
      return (
        <GeofenceActionModal
          exception={selectedException}
          open={open}
          onClose={onClose}
          onResolve={onResolve}
        />
      );
    case "late_arrival":
    case "replacement":
    case "wrong_site":
      return (
        <GenericResolveModal
          exception={selectedException}
          open={open}
          onClose={onClose}
          onResolve={onResolve}
        />
      );
    default:
      return null;
  }
};

export default ExceptionActionModalRouter;
